// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audio-recording__container {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    padding: 10px;
}

.audio-recording__placeholder {
    min-height: 54px;
    background-color: #e6e6e6;
    border-radius: 100px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 0 20px;
}

.audio-recording__placeholder-icon {
    font-size: 5rem;
    color: rgba(0, 0, 0, 0.61);
}

.audio-recording__placeholder-track {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.61);
    height: 4px;
    border: none;
    border-radius: 10px;
    margin-right: 10px;
    margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/recording-dialog/audio-recording-preview/AudioRecordingPreview.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;IACpB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,qCAAqC;IACrC,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".audio-recording__container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.3rem;\r\n    padding: 10px;\r\n}\r\n\r\n.audio-recording__placeholder {\r\n    min-height: 54px;\r\n    background-color: #e6e6e6;\r\n    border-radius: 100px;\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0 20px;\r\n}\r\n\r\n.audio-recording__placeholder-icon {\r\n    font-size: 5rem;\r\n    color: rgba(0, 0, 0, 0.61);\r\n}\r\n\r\n.audio-recording__placeholder-track {\r\n    width: 100%;\r\n    background-color: rgba(0, 0, 0, 0.61);\r\n    height: 4px;\r\n    border: none;\r\n    border-radius: 10px;\r\n    margin-right: 10px;\r\n    margin-left: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
